import { render, staticRenderFns } from "./contattoView.vue?vue&type=template&id=09cf77bf"
import script from "./contattoView.vue?vue&type=script&lang=js"
export * from "./contattoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports